import * as React from 'react';
import classnames from 'classnames';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { Table, TableContainer, TableHead, TableRow } from 'components/table';

import DeliverablesMetricsInstagramStoryAnalyticForm from 'modules/admin/components/deliverables/metrics-instagram-story-analytics/DeliverablesMetricsInstagramStoryAnalyticForm';
import SortableAnalyticsContainer from '../dnd/SortableAnalyticsContainer';
import DroppableAttachmentContainer from '../dnd/DroppableAttachmentContainer';

import { __t, applyTranslations } from 'utils/language';

import type { AdminAnalytic, DeliverableAnalytic, DeliverableAttachment, DeliverableAttachmentType } from 'types';

import './deliverable-metrics-story-form.scss';

applyTranslations(require('./deliverable-metrics-story-form.i18n.json'));

type Props = {
  deliverableId: number,
  attachments?: Array<DeliverableAttachment>,
  analytics: Array<DeliverableAnalytic>,
  canUploadSnippet?: boolean,
  disableDragAndDrop?: boolean,
  hideAnalyticsColumn?: boolean,
  isFullscreen?: boolean,
  onAddDeliverableMetric: () => Promise<void>,
  onUpdateDeliverableMetrics: (d: number, c: number, b: number, a: AdminAnalytic) => Promise<void>,
  onDeleteDeliverableMetricsAnalytics: (c: number, b: number, a: number) => void,
  onDeliverableAttachmentUpload?: (c: number, b: DeliverableAttachmentType, a: Array<File>) => void,
  onUnMatchDeliverableAttachment?: (c: number, b: number, a: number) => void
};

class DeliverablesMetricsInstagramStoryForm extends React.Component<Props> {
  static defaultProps = {
    isFullscreen: true
  };

  renderAnalyticRow = (
    index: number,
    postAttachments: Array<DeliverableAttachment>,
    analytic: DeliverableAnalytic,
    deliverableId: number
  ) => {
    const { isFullscreen } = this.props;
    const formKey = [
      analytic.id,
      analytic.reach,
      analytic.impressions,
      analytic.interactions,
      analytic.profileVisits,
      analytic.websiteVisits,
      analytic.stickerTaps,
      analytic.linkClicks
    ].join();
    const form = (
      <DeliverablesMetricsInstagramStoryAnalyticForm
        key={formKey}
        index={index + 1}
        deliverableId={deliverableId}
        analytic={analytic}
        isFullScreen={isFullscreen}
        attachments={postAttachments}
        canUploadSnippet={this.props.canUploadSnippet}
        disableDragAndDrop={this.props.disableDragAndDrop}
        hideAnalyticsColumn={this.props.hideAnalyticsColumn}
        onDeliverableAttachmentUpload={this.props.onDeliverableAttachmentUpload}
        onUpdateDeliverableMetrics={this.props.onUpdateDeliverableMetrics}
        onDeleteDeliverableMetricsAnalytics={this.props.onDeleteDeliverableMetricsAnalytics}
        onUnMatchDeliverableAttachment={this.props.onUnMatchDeliverableAttachment}
      />
    );

    if (this.props.disableDragAndDrop) {
      return form;
    }

    return (
      <DroppableAttachmentContainer
        key={index}
        id={deliverableId}
        analyticId={analytic.id}
      >
        {form}
      </DroppableAttachmentContainer>
    );
  };

  render(): React.ReactNode {
    const {
      deliverableId,
      disableDragAndDrop,
      hideAnalyticsColumn,
      onAddDeliverableMetric,
      isFullscreen
    } = this.props;

    const analytics = this.props.analytics.map((analytic, index) => (
      this.renderAnalyticRow(index, this.props.attachments || [], analytic, deliverableId))
    );

    const containerClasses = classnames({
      'deliverables-metrics-instagram-story-form': true,
      'deliverables-metrics-instagram-story-form--short-width-table': !isFullscreen
    });

    const thClasses = classnames('deliverables-metrics-instagram-story-form__table-head', {
      'deliverables-metrics-instagram-story-form__table-head--is-limited-width': !isFullscreen
    });

    return (
      <section className={containerClasses}>
        <TableContainer className="deliverables-metrics-instagram-story-form__table-with-overflow">
          <Table style="none">
            <TableRow>
              <TableHead width="micro" />
              <TableHead className={thClasses}>{__t('deliverable_metrics_story_form.label_snippet')}</TableHead>
              <TableHead className={thClasses}>
                {
                  !hideAnalyticsColumn && __t('deliverable_metrics_story_form.label_analytics')
                }
              </TableHead>
              <TableHead className={thClasses}>{__t('deliverable_metrics_story_form.label_reach')}</TableHead>
              <TableHead className={thClasses}>{__t('deliverable_metrics_story_form.label_impressions')}</TableHead>
              <TableHead className={thClasses}>{__t('deliverable_metrics_story_form.label_interactions')}</TableHead>
              <TableHead className={thClasses}>{__t('deliverable_metrics_story_form.label_profile_visits')}</TableHead>
              <TableHead className={thClasses}>{__t('deliverable_metrics_story_form.label_website_visits')}</TableHead>
              <TableHead className={thClasses}>{__t('deliverable_metrics_story_form.label_sticker_taps')}</TableHead>
              <TableHead className={thClasses}>{__t('deliverable_metrics_story_form.label_link_clicks')}</TableHead>
              <TableHead className={thClasses}>{__t('deliverable_metrics_story_form.label_actions')}</TableHead>
            </TableRow>
            {
              disableDragAndDrop ?
                analytics :
                <SortableAnalyticsContainer id={deliverableId}>
                  {analytics}
                </SortableAnalyticsContainer>
            }
          </Table>
        </TableContainer>
        <div className="deliverables-metrics-instagram-story-form__panel">
          <ActionButton
            width="minimum"
            onClick={onAddDeliverableMetric}
          >
            {__t('deliverable_metrics_story_form.button_add')}
          </ActionButton>
        </div>
      </section>
    );
  }
}

export default DeliverablesMetricsInstagramStoryForm;
